export default __webpack_public_path__ + "static/headerPattern-f9c5ca275ea6e365a3359dd927a93a54.svg";